import type React from "react"

export const Menus = (props: React.ComponentProps<"svg">): JSX.Element => (
    <svg width='24' height='24' fill='none' {...props}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.33586 9.29467C9.85983 8.90002 10.4791 8.65446 11.1128 8.53821C11.2796 8.21836 11.6143 7.99999 12 7.99999C12.3857 7.99999 12.7204 8.21836 12.8872 8.53821C13.5209 8.65446 14.1402 8.90002 14.6641 9.29467C15.4606 9.89457 16 10.818 16 12C16 12.5523 15.5523 13 15 13H9C8.44772 13 8 12.5523 8 12C8 10.818 8.5394 9.89457 9.33586 9.29467ZM13.4609 10.8922C13.506 10.9262 13.5489 10.9621 13.5893 11H10.4107C10.4511 10.9621 10.494 10.9262 10.5391 10.8922C10.8959 10.6235 11.4228 10.4579 12 10.4579C12.5772 10.4579 13.1041 10.6235 13.4609 10.8922Z'
            fill='currentColor'
        />
        <path
            d='M12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14H12Z'
            fill='currentColor'
        />
        <path
            d='M12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19H15C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17H12Z'
            fill='currentColor'
        />
        <path
            d='M10 15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14C9.55228 14 10 14.4477 10 15Z'
            fill='currentColor'
        />
        <path
            d='M10 18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18C8 17.4477 8.44772 17 9 17C9.55228 17 10 17.4477 10 18Z'
            fill='currentColor'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17 4.36445C17 3.01267 15.6868 2.05022 14.3977 2.45729L6.11672 5.13208C4.89096 5.50916 4 6.6505 4 7.99993V19C4 20.6568 5.34315 22 7 22H17C18.6569 22 20 20.6568 20 19V7.99935C20 6.34252 18.6569 4.99993 17 4.99993V4.36445ZM15 4.99993H13.0335L15 4.36448V4.99993ZM7 6.99994H15.9897L16 6.99999L16.0103 6.99994H17.0006C17.5529 6.99994 18 7.44705 18 7.99935V19C18 19.5523 17.5523 20 17 20H7C6.44771 20 6 19.5523 6 19V7.99993C6 7.44765 6.44772 6.99994 7 6.99994Z'
            fill='currentColor'
        />
    </svg>
)
